module.exports = __webpack_public_path__ + "img/video-loading.62f41efe.gif";